import m from "../../geodata/es2015/elSalvadorHigh";
window.am4geodata_elSalvadorHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/elSalvadorHigh.js
// module id = null
// module chunks = 